import { useEffect, useState } from 'react';

import ContractsPagination from './components/ListTable/ContractsPagination'

import { Box, Stack } from '@mui/material';
import {Add } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { ContractationButtons } from '../NavigationMenu/Header/CustomItems/ContractationButtons';
import { useSettingsContext } from '../Settings/hooks/useSettingsContext';
import { useContracts } from './hooks/useContracts';
import { ContractsGasListTable } from './components/ListTable/ContractsGasListTable';
import ContractsFilter from './components/ContractsFilter';
import { IGasContract } from './types/contracts';
import useContractation from '../Contractation/hooks/useContractation';

const ContractsListGas = () => {
  const { t } = useTranslation();
  const Settings = useSettingsContext();

  const { 
    contracts,
    totalContractsNum,
    status, 
    fetchContracts,
    goToContract,
    goToFilteredInvoices,
  } = useContracts("gas");

  const { isContractationActive } = useContractation();

  const [filter, setFilter] = useState('');
  const [itemsPerPage, setItemsPerPage] = useState(Settings?.contracts?.itemsPerPage ?? 10);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    if (currentPage > 1) {
      setCurrentPage(1);
    }
  }, [filter, itemsPerPage]);

  useEffect(() => {
    if (status != "uninitialized" && status != "loading") {
      fetchContracts(false, currentPage, itemsPerPage, filter);
    }
  }, [filter, itemsPerPage, currentPage]);

  return (
    <>
      <Stack spacing={3}>

        <Stack 
          direction={{md: "row"}} 
          gap={2}
          justifyContent="space-between"
          alignItems={{xs: "initial", md: "top"}}
        >
          {!Settings?.contracts?.dontShowSearchFilter &&
            <ContractsFilter 
              loading={status === "loading"}
              setFilter={setFilter}
            />
          }

          {isContractationActive && <Box>
            <ContractationButtons 
              startIcon={<Add />}
              label={t("common:text.new_customer_title")}
            />
          </Box>}
          
        </Stack>

        <ContractsGasListTable 
          contracts={contracts as IGasContract[]} 
          status={status} 
          goToContract={goToContract}
          goToFilteredInvoices={goToFilteredInvoices}
        />

        <ContractsPagination 
          currentPage={currentPage}
          itemsPerPage={itemsPerPage}
          itemsTotal={totalContractsNum}
          setItemsPerPage={setItemsPerPage}
          setCurrentPage={setCurrentPage}
        />

      </Stack>
    </>
  );

}

export default ContractsListGas;
